module.exports = __webpack_public_path__ + "img/remind@2x.9ae081f7.png";